const READING_FRANCHISE_TAB_STORAGE_KEY = "redwing-reading-franchise-tab";
const FRANCHISE_TAB_COUNT = 4;

export const getValidReadingTabIndex = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const index = Number(value);

  return Number.isInteger(index) && index >= 0 && index < FRANCHISE_TAB_COUNT
    ? index
    : null;
};

export const getReadingTabIndexFromFranchise = (franchiseTab) => {
  const index = Number(franchiseTab) - 1;

  return getValidReadingTabIndex(index);
};

export const getStoredReadingTabIndex = () => {
  try {
    return (
      getValidReadingTabIndex(
        window.localStorage.getItem(READING_FRANCHISE_TAB_STORAGE_KEY)
      ) ?? 0
    );
  } catch {
    return 0;
  }
};

export const persistReadingTabIndex = (index) => {
  const validIndex = getValidReadingTabIndex(index);

  if (validIndex === null) {
    return;
  }

  try {
    window.localStorage.setItem(
      READING_FRANCHISE_TAB_STORAGE_KEY,
      String(validIndex)
    );
  } catch {
    return;
  }
};

export { READING_FRANCHISE_TAB_STORAGE_KEY };
